import SubMenuItem from "./SubMenuItem";
import { MenuOption } from "./SubMenuItem";

export interface MenuItem {
        name:string;
        icon:React.ReactNode;
        options:MenuOption[];
    }

const MenuItem = ({name, options,icon}:MenuItem) => {
    return <li className="nav-item dropdown" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
        <a className="nav-link dropdown-toggle naranja monse" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" title={name}>
            <div style={{height:"52px"}} className="text-center d-flex flex-column justify-content-end align-items-center">
            {icon}
            <h6 style={{ fontSize: "13px", marginTop: "5px", marginBottom: "0px", fontWeight: "500" }}>{name}</h6>
            </div>
        </a>
        <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            {options.map((opt:MenuOption, i) =>  <SubMenuItem  key={i} {...opt} /> )}
        </ul>
    </li>
}

export default MenuItem